import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VendorListLayer from "../components/VendorListLayer";

const VendorListPage = () => {
    return (
        <MasterLayout>
            <VendorListLayer />
        </MasterLayout>
    );
};

export default VendorListPage;
